import { render, staticRenderFns } from "./KousakuTown.vue?vue&type=template&id=9305e726&scoped=true&"
import script from "./KousakuTown.vue?vue&type=script&lang=js&"
export * from "./KousakuTown.vue?vue&type=script&lang=js&"
import style0 from "./KousakuTown.vue?vue&type=style&index=0&id=9305e726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9305e726",
  null
  
)

export default component.exports